import { render } from "./CargoPropertyForm.vue?vue&type=template&id=0f070370&scoped=true"
import script from "./CargoPropertyForm.vue?vue&type=script&lang=js"
export * from "./CargoPropertyForm.vue?vue&type=script&lang=js"

import "./CargoPropertyForm.vue?vue&type=style&index=0&id=0f070370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f070370"]])

export default __exports__